import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';
import { ProfileModel } from '../../../features/profile/models/profile.model';
import { ProfileService } from '../../../features/profile/services/profile.service';

@Component({
  selector: 'app-profile-bar',
  templateUrl: './profile-bar.component.html',
  styleUrls: ['./profile-bar.component.css'],
  standalone: false,
})
export class ProfileBarComponent implements OnInit, OnDestroy {
  profile: ProfileModel;

  subscription: Subscription;

  // Labels
  editButtonLabel: string;

  constructor(
    private profileService: ProfileService,
    private persianTitlesService: PersianTitlesService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initMyProfile();
    this.initLabels();

    // Listen for default charity changes
    window.addEventListener('defaultCharityChanged', () => {
      this.initMyProfile();
    });
  }

  onEditProfile() {
    this.router.navigate(['profile', 'edit']);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private initMyProfile() {
    this.subscription = this.profileService
      .getMyProfile()
      .subscribe((profile) => {
        // Create ProfileModel instance to get charityTitle getter
        this.profile = new ProfileModel(
          profile.id,
          profile.firstName,
          profile.lastName,
          profile.fullName,
          profile.email,
          profile.mobileNumber,
          profile.linkedin,
          profile.cooperation_type,
          profile.lastEducationDegree,
          profile.educationField,
          profile.charities,
          profile.defaultCharityId,
          profile.positionsTitle,
          profile.hasApprovalRequired,
          profile.hasApprovalForRegistering,
          profile.avatar,
          (profile as any).gender,
        );

        // Set defaultCharityId in localStorage
        if (profile.defaultCharityId) {
          let userData = JSON.parse(
            localStorage.getItem('afraTrainingPortalUserData') || '{}',
          );
          userData.defaultCharityId = profile.defaultCharityId;
          localStorage.setItem(
            'afraTrainingPortalUserData',
            JSON.stringify(userData),
          );
        }
      });
  }

  private initLabels() {
    this.editButtonLabel = this.persianTitlesService.Items.Edit;
  }
}
